export default function () {
  const $pricingCalculatorWindow = $(window);
  const $pricingCalculatorBody = $('body');
  const $pricingCalculatorSection = $('.pricing-calculator');
  const $pricingCalculatorMobileWrapper = $('.pricing-calculator-summary-mobile-wrapper');
  let pricingCalculatorInitiated = false;

  function formatCurrency(value) {
    const language = $('html').attr('lang');
    if (language === 'gb') {
      return '£' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').toString();
    } else {
      return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').toString().replace(/.([^.]*)$/, ',$1') + ' €';
    }
  }

  function checkMobileSummaryBox() {
    if ($pricingCalculatorWindow.scrollTop() + $pricingCalculatorWindow.height() + $('.pricing-calculator-summary-wrapper').height() < $pricingCalculatorSection.offset().top + 500 || ($pricingCalculatorWindow.height() + $pricingCalculatorWindow.scrollTop()) > ($pricingCalculatorSection.offset().top + $pricingCalculatorSection.height() - parseInt($pricingCalculatorSection.find('.inner').css('padding-bottom'), 10))) {
      $pricingCalculatorMobileWrapper.addClass('pricing-calculator-summary-stick-to-section').addClass('block-hidden');
    } else {
      $pricingCalculatorMobileWrapper.removeClass('pricing-calculator-summary-stick-to-section');
    }

    if ($pricingCalculatorWindow.width() > 1023) {
      $pricingCalculatorMobileWrapper.addClass('block-hidden');
      $pricingCalculatorBody.removeClass('pricing-calculator-modal-open');
    }
  }

  function calculateTotal() {
    if (pricingCalculatorInitiated) {
      $pricingCalculatorSection.removeClass('pricing-calculator-initial');
    }

    const users = Number($('.pricing-calculator-category-users .slider-input').val());
    const checkboxOption = $('#option').is(':checked');
    let sumMonthly = 0;
    let sumOneTime = 0;
    let priceListEntriesMonthly = '';
    let priceListEntriesOneTime = '';
    let showOneTime = false;

    const $flatrates = $('.pricing-calculator-category-flatrates');
    let flatratesSumMonthly = 0;
    if ($flatrates.find('.pricing-calculator-flatrates-limited')) {
      const flatratesLimitedText = $flatrates.find('.pricing-calculator-flatrates-limited');
      const flatratesLimitedValue = Number($flatrates.data('flatrates-limited-activation'));
      if (flatratesLimitedValue > users) {
        flatratesLimitedText.show();
        $flatrates.find('.pricing-calculator-tile-selected').removeClass('pricing-calculator-tile-selected');
      } else {
        flatratesLimitedText.hide();
        $flatrates.find('.pricing-calculator-tile').each(function () {
          const $tile = $(this);
          if ($tile.hasClass('pricing-calculator-tile-selected') && users > 0) {
            flatratesSumMonthly += users * Number($tile.data('price-monthly'));
          }
        });
      }
    }
    $flatrates.data('total-monthly', flatratesSumMonthly);

    const $integrations = $('.pricing-calculator-category-integrations');
    let integrationsSumMonthly = 0;
    let integrationsSumAmount = 0;
    /*
     * When users tick the “Add Webex”:
     * - the flatrate price should drop to 0
     * - integrations pricing should drop to 0
     * - SIM cards should also drop to 0
     */
    const webexIsSelected = $('#option').is(':checked');

    $integrations.find('.pricing-calculator-tile').each(function () {
      const $tile = $(this);
      const amount = Number($tile.find('.amount-input').val());

      if (!amount || !$tile.hasClass('pricing-calculator-tile-selected')) {
        return;
      }

      integrationsSumMonthly += amount * Number($tile.data('price-monthly'));
      integrationsSumAmount += amount;
    });

    $integrations.data('total-monthly', integrationsSumMonthly);
    $integrations.data('total-onetime', 0);

    const $integrations2 = $('.pricing-calculator-category-integrations2');
    let integrations2SumMonthly = 0;
    let integrations2SumAmount = 0;
    $integrations2.find('.pricing-calculator-tile').each(function () {
      const $tile = $(this);
      const amount = Number($tile.find('.amount-input').val());
      if ($tile.hasClass('pricing-calculator-tile-selected') && amount > 0) {
        integrations2SumMonthly += amount * Number($tile.data('price-monthly'));
        integrations2SumAmount += amount;
      }
    });
    $integrations2.data('total-monthly', integrations2SumMonthly);
    $integrations2.data('total-onetime', 0);

    const $hardware = $('.pricing-calculator-category-hardware');
    const checkboxMonthly = $hardware.find('#hardware-monthly').is(':checked');
    let hardwareSumMonthly = 0;
    let hardwareSumOneTime = 0;
    let hardwareSumAmount = 0;
    $hardware.find('.pricing-calculator-tiles-hardware-selected .pricing-calculator-tile').each(function () {
      const $tile = $(this);
      const amount = Number($tile.find('.amount-input').val());
      if ($tile.hasClass('pricing-calculator-tile-selected') && amount > 0) {
        if (checkboxMonthly) {
          hardwareSumMonthly += amount * Number($tile.data('price-monthly'));
        } else {
          hardwareSumOneTime += amount * Number($tile.data('price-onetime'));
        }
        hardwareSumAmount += amount;
      }
    });
    $hardware.data('total-monthly', hardwareSumMonthly);
    $hardware.data('total-onetime', hardwareSumOneTime);

    const $sims = $('.pricing-calculator-category-sims');
    let simsSumMonthly = 0;
    let simsSumOneTime = 0;
    let simsSumAmount = 0;
    $sims.find('.pricing-calculator-tile').each(function () {
      const $tile = $(this);
      const amount = Number($tile.find('.amount-input').val());
      if ($tile.hasClass('pricing-calculator-tile-selected') && amount > 0) {
        simsSumMonthly += amount * Number($tile.data('price-monthly'));
        simsSumOneTime += Number($tile.data('price-onetime'));
        simsSumAmount += amount;
      }
    });

    $sims.data('total-monthly', simsSumMonthly);
    $sims.data('total-onetime', simsSumOneTime);

    if (webexIsSelected) {
      $('.pricing-calculator-category-sims .pricing-calculator-tile-selected img').each(function () {
        $(this).click();
      });
    }

    $('.pricing-calculator-category').each(function () {
      const $this = $(this);
      let monthly = Number($this.data('total-monthly'));
      const onetime = Number($this.data('total-onetime'));
      const value = Number($this.data('value'));
      let text = value === 1 ? $this.data('summary') : $this.data('summary-plural');
      let replaceValue = value;
      let flatText = '';
      let freeClassMonthly = '';
      let freeClassOneTime = '';

      if ($this.data('flat-activated') && $this.data('flat-activation') && Number($this.data('flat-activation')) <= value * Number($this.data('price-monthly'))) {
        flatText = ' <span class="pricing-calculator-summary-prices-flat-text">' + $this.data('flat-activated') + '</span>';
        text = users === 1 ? $this.data('summary-flat') : $this.data('summary-flat-multiple');
      }

      if (webexIsSelected && text === '{{value}} Mobile SIM') {
        // in some conditions the amount volume does not update
        simsSumAmount = 0;
      }

      if ($this.hasClass('pricing-calculator-category-users')) {
        if (checkboxOption) {
          text = users === 1 ? $this.data('option-summary') : $this.data('option-summary-plural');
        } else {
          text = users === 1 ? $this.data('summary') : $this.data('summary-plural');
        }
      } else if ($this.hasClass('pricing-calculator-category-integrations')) {
        replaceValue = integrationsSumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      } else if ($this.hasClass('pricing-calculator-category-integrations2')) {
        replaceValue = integrations2SumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      } else if ($this.hasClass('pricing-calculator-category-hardware')) {
        replaceValue = hardwareSumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      } else if ($this.hasClass('pricing-calculator-category-sims')) {
        replaceValue = simsSumAmount;
        text = replaceValue === 1 ? $this.data('summary') : $this.data('summary-plural');
      }

      if (monthly !== 0 || $this.data('show-zero-monthly') === 1) {
        if (monthly === 0 && $this.data('show-zero-monthly') === 1) {
          freeClassMonthly = ' class="pricing-calculator-summary-price-free"';
        }
        if (webexIsSelected && monthly > 0 && (
            text === 'Integration' ||
            text === 'Integrationen' ||
            text === 'Flatrates' ||
              text === 'MS-Teams'
          )) {
          monthly = 0;
        }
        priceListEntriesMonthly += '<li' + freeClassMonthly + '><div>' + text.replace('{{value}}', replaceValue).replace('{{users}}', users) + flatText + '</div><div>' + formatCurrency(monthly) + '</div></li>';
      }
      if (onetime !== 0 || $this.data('show-zero-one-time') === 1) {
        if (onetime === 0 && $this.data('show-zero-one-time') === 1) {
          freeClassOneTime = ' class="pricing-calculator-summary-price-free"';
          showOneTime = true;
        }
        priceListEntriesOneTime += '<li' + freeClassOneTime + '><div>' + text.replace('{{value}}', replaceValue).replace('{{users}}', users) + '</div><div>' + formatCurrency(onetime) + '</div></li>';
      }

      sumMonthly += monthly;
      sumOneTime += onetime;
    });

    $('.pricing-calculator-summary-prices-monthly').html((priceListEntriesMonthly !== '' ? priceListEntriesMonthly : ''));
    $('.pricing-calculator-summary-prices-one-time').html((priceListEntriesOneTime !== '' ? priceListEntriesOneTime : ''));
    $('.pricing-calculator-summary-total-price-wrapper-monthly .pricing-calculator-summary-total-price span').html(formatCurrency(sumMonthly));
    $('.pricing-calculator-summary-total-price-wrapper-one-time .pricing-calculator-summary-total-price span').html(formatCurrency(sumOneTime));
    if (sumOneTime > 0 || showOneTime) {
      $('.pricing-calculator-summary-one-time').removeClass('pricing-calculator-summary-one-time-hide');
    } else {
      $('.pricing-calculator-summary-one-time').addClass('pricing-calculator-summary-one-time-hide');
    }

    if (checkboxOption) {
      $('.pricing-calculator-summary').addClass('pricing-calculator-summary-with-option');
    } else {
      $('.pricing-calculator-summary').removeClass('pricing-calculator-summary-with-option');
    }

    pricingCalculatorInitiated = true;
  }

  function syncSliderValue($this, type) {
    const range = $this.parent().parent().find('.slider-range');
    const bubble = $this.parent().parent().find('.slider-bubble');
    const input = $this.parent().parent().find('.slider-input');
    const value = $this.val();
    const bulletPosition = (Number(value - Number($this.attr('min'))) / (Number($this.attr('max')) - Number($this.attr('min'))));
    const bulletPositionPercent = (Number(value - Number($this.attr('min'))) / (Number($this.attr('max')) - Number($this.attr('min')))) * 100;
    bubble.html(value + ' ' + bubble.data('text'));
    bubble.css({ left: (bulletPosition * (range.width() - 34)) + 16 + 'px' });
    range.css({ background: 'linear-gradient(to right, var(--color-green-darker) 0%, var(--color-green-darker) ' + bulletPositionPercent + '%, var(--color-grey-light) ' + bulletPositionPercent + '%, var(--color-grey-light) 100%)' });
    if (type === 'range') {
      input.val(value);
    } else {
      range.val(value);
    }
    bubble.removeClass('slider-bubble-hide');
  }

  if ($pricingCalculatorSection.length) {
    calculateTotal();

    $('.pricing-calculator input[type="range"]').each(function () {
      const $this = $(this);
      syncSliderValue($this, 'range');
    });

    $('.pricing-calculator input').change(function () {
      $('.pricing-calculator input:not([type="checkbox"])').each(function () {
        event.preventDefault();
        const $this = $(this);
        const value = $this.val();
        const $category = $this.closest('.pricing-calculator-category');
        const users = $('.pricing-calculator-category-users .slider-input').val();
        const amount = Number(value);
        const perUser = ($category.data('price-per-user') === 1 && !$category.hasClass('pricing-calculator-category-users')) ? amount * users : amount;

        if ($category.hasClass('pricing-calculator-category-users')) {
          const checkboxOption = $('#option').is(':checked');
          let price = checkboxOption ? Number($category.data('price-option-monthly')) : Number($category.data('price-monthly'));
          let total = price * perUser;
          $category.data('total-monthly', total);

          price = checkboxOption ? Number($category.data('price-option-onetime')) : Number($category.data('price-onetime'));
          total = price * perUser;
          $category.data('total-onetime', total);

          if ($category.find('.pricing-calculator-individual-offer')) {
            const individualOfferText = $category.find('.pricing-calculator-individual-offer');
            const individualOfferValue = Number($category.data('individual-offer-activation'));
            if (individualOfferValue <= users) {
              individualOfferText.show();
            } else {
              individualOfferText.hide();
            }
          }
          /*        } else if ($category.hasClass('pricing-calculator-category-minutes')) {
                    const activationText = $category.find('.pricing-calculator-flat-activated');
                    const flatValue = Number($category.data('flat-activation'));
                    if (flatValue <= value * Number($category.data('price-monthly'))) {
                      $category.data('total-monthly', flatValue * users);
                      activationText.show();
                    } else {
                      const price = Number($category.data('price-monthly'));
                      const total = price * perUser;
                      $category.data('total-monthly', total);
                      activationText.hide();
                    }*/
        } else {
          let price = Number($category.data('price-monthly'));
          let total = price * perUser;
          $category.data('total-monthly', total);

          price = Number($category.data('price-onetime'));
          total = price * perUser;
          $category.data('total-onetime', total);
        }
        $category.data('value', value);
        if ($this.hasClass('slider-input')) {
          syncSliderValue($this, 'input');
        }
      });
      calculateTotal();
    });

    $pricingCalculatorSection.on('input', 'input[type="range"]', function () {
      const $this = $(this);
      if ($this.attr('type') === 'range') {
        syncSliderValue($this, 'range');
      }
    });

    $('.pricing-calculator-tile-image').click(function () {
      const $tile = $(this).parent();
      $tile.toggleClass('pricing-calculator-tile-selected');
      if ($tile.data('category')) {
        $('.pricing-calculator-tiles-hardware').removeClass('pricing-calculator-tiles-hardware-first').removeClass('pricing-calculator-tiles-hardware-last');
        $('.pricing-calculator-tiles-hardware-' + $tile.data('category')).toggleClass('pricing-calculator-tiles-hardware-selected');
        $('.pricing-calculator-tiles-hardware:visible:first').addClass('pricing-calculator-tiles-hardware-first');
        $('.pricing-calculator-tiles-hardware:visible:last').addClass('pricing-calculator-tiles-hardware-last');
      } else if ($tile.closest('.pricing-calculator-category').hasClass('pricing-calculator-category-flatrates')) {
        $tile.siblings().removeClass('pricing-calculator-tile-selected');
      }
      calculateTotal();
    });

    $('.pricing-calculator-tile-button').click(function () {
      const $this = $(this);
      const isNegative = $this.hasClass('pricing-calculator-tile-button-minus');
      const input = $this.parent().find('.amount-input');
      input[0][isNegative ? 'stepDown' : 'stepUp']();
      calculateTotal();
    });

    $('.pricing-calculator-show-more').click(function () {
      calculateTotal();
      checkMobileSummaryBox();
    });

    $('.pricing-calculator-summary-mobile-button, .pricing-calculator-summary-backdrop').click(function () {
      const $this = $(this);
      $this.closest('.pricing-calculator-summary-mobile-wrapper').toggleClass('block-hidden');
      $pricingCalculatorBody.toggleClass('pricing-calculator-modal-open');
    });

    $pricingCalculatorWindow.on('resize scroll load', function () {
      checkMobileSummaryBox();
    });
  }
}
